export async function uploadImageToCloudinary(file, createdBy) {
  const cloudName = import.meta.env.VITE_CLOUDINARY_CLOUD_NAME;
  const preset = import.meta.env.VITE_CLOUDINARY_UPLOAD_PRESET_IMAGE;

  if (!cloudName || !preset) {
    throw new Error('Cloudinary environment variables are missing.');
  }

  const form = new FormData();
  form.append('file', file);
  form.append('upload_preset', preset);
  form.append('context', `createdBy=${createdBy || 'unknown'}`);

  const resp = await fetch(`https://api.cloudinary.com/v1_1/${cloudName}/image/upload`, {
    method: 'POST',
    body: form,
  });

  if (!resp.ok) {
    throw new Error('Cloudinary upload failed.');
  }

  const data = await resp.json();
  return {
    secureUrl: data.secure_url,
    publicId: data.public_id,
    width: data.width,
    height: data.height,
    bytes: data.bytes,
    format: data.format,
    createdBy: createdBy || null,
    createdAt: new Date().toISOString(),
  };
}

export async function deleteImagesFromCloudinary(publicIds, requestedBy) {
  const gasEndpoint = import.meta.env.VITE_GAS_ACCOUNT_ENDPOINT;
  const gasSharedToken = import.meta.env.VITE_GAS_SHARED_TOKEN || 'drsfarmttadmincontrol';
  const uniquePublicIds = [...new Set((publicIds || []).map((value) => String(value || '').trim()).filter(Boolean))];

  if (!uniquePublicIds.length) {
    return { deleted: [], failed: [] };
  }
  if (!gasEndpoint) {
    throw new Error('GASエンドポイントが未設定です。');
  }

  const response = await fetch(gasEndpoint, {
    method: 'POST',
    headers: { 'Content-Type': 'text/plain;charset=utf-8' },
    body: JSON.stringify({
      action: 'deleteCloudinaryImages',
      publicIds: uniquePublicIds,
      requestedBy: requestedBy || '',
      token: gasSharedToken,
    }),
  });

  if (!response.ok) {
    throw new Error(`gas-error-${response.status}`);
  }

  const data = await response.json();
  if (data?.ok === false) {
    throw new Error(data.error || 'cloudinary-delete-failed');
  }
  if (Array.isArray(data?.failed) && data.failed.length) {
    throw new Error(`cloudinary-delete-failed:${data.failed.map((item) => item.publicId).join(',')}`);
  }

  return data;
}
